import React from "react";
import { Link } from "react-router-dom";

/**
 * Button / link with design-system variants.
 * variant: "primary" | "secondary" | "ghost"
 * Renders <Link> when `to` is set, <a> when `href` is set, otherwise <button>.
 */
const variants = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  ghost:
    "inline-flex items-center justify-center gap-2 font-label-sm text-label-sm font-bold uppercase tracking-wider text-primary hover:text-primary-container transition-colors",
};

const Button = ({
  variant = "primary",
  to,
  href,
  className = "",
  children,
  ...rest
}) => {
  const classes = `${variants[variant] || variants.primary} ${className}`;

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={classes} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  );
};

export default Button;
